import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { environment } from 'src/environments/environment.prod';
import { JwtHelperService } from '@auth0/angular-jwt';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Users } from 'src/app/models/users.model';
import { AuthResponseDto } from '../models/authResponseDto';
import { RegistrationResponseDto } from '../models/registrationResponseDto';
import { UserForAuthenticationDto } from '../models/userForAuthenticationDto';
import { UserForRegistrationDto } from '../models/userForRegistrationDto';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private _authChangeSub = new Subject<boolean>()


  public authChanged = this._authChangeSub.asObservable();
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  constructor(private _http: HttpClient, private _jwtHelper: JwtHelperService,
    private router: Router
  ) { }
  public isUserAuthenticated = (): boolean => {
    const token = localStorage.getItem("token");

    return token && !this._jwtHelper.isTokenExpired(token);
  }

  public registerUser = (route: string, body: UserForRegistrationDto) => {
    return this._http.post<RegistrationResponseDto>(this.createCompleteRoute(route, environment.apiUrl), body);
  }
  public updateUser = (route: string, body: any) => {
    return this._http.put<any>(this.createCompleteRoute(route, environment.apiUrl), body);
  }

  resetPassword$(userId: string, token: string, password: string): Observable<any> {
    const url = `${environment.apiUrl}/accounts/reset-password`;
    const body = {
      userId,
      token,
      password
    };
    return this._http.post<any>(url, body, this.httpOptions);
  }
  
  forgetPassword$(email: string): Observable<string> {
    let url = `${environment.apiUrl}/accounts/forgetPassword?email=${email}`;
    return this._http.post<string>(url, this.httpOptions).pipe(
      map((body: any) => body)
    )
  }
  loginGoogle$(model: any): Observable<any> {
    let url = `${environment.apiUrl}/ScialAuthentication/GoogleSignIn`;
    return this._http.post<string>(url, model, this.httpOptions).pipe(
      map((body: any) => body)
    )
  }


  public loginUser = (route: string, body: UserForAuthenticationDto) => {
    return this._http.post<AuthResponseDto>(this.createCompleteRoute(route, environment.apiUrl), body);
  }
  public isUserAdmin = (): boolean => {
    const token = localStorage.getItem("token");
    const decodedToken = this._jwtHelper.decodeToken(token);
    const role = decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']
    return role === 'Administrator';
  }
  public logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userName");
    localStorage.removeItem("userId");
    localStorage.removeItem("permetions");
    this.sendAuthStateChangeNotification(false);

    this.router.navigate([''], {
      queryParams: {},
    }).then(() => {
      // Refresh the page after navigation
      location.reload();
    });
  }


  public sendAuthStateChangeNotification = (isAuthenticated: boolean) => {
    this._authChangeSub.next(isAuthenticated);
  }

  private createCompleteRoute = (route: string, envAddress: string) => {
    return `${envAddress}${route}`;
  }


  getUserDetail$(): Observable<any> {
    let url = `${environment.apiUrl}/Users/getUserDetails`;
    return this._http.get<any>(url, this.httpOptions).pipe(
      map((body: any) => body)
    )
  }
  getUserDetailToShow$(): Observable<any> {
    let url = `${environment.apiUrl}/Users/GetUserDetailToShow`;
    return this._http.get<any>(url, this.httpOptions).pipe(
      map((body: any) => body)
    )
  }
}
